module.exports = __webpack_public_path__ + "static/media/live-cover-mobile.6fa60ad4.jpg";